'use strict'

const Handlebars = require('handlebars')

const Wildcard = '*'

const Effect = {
    Allow: 'Allow'
}

const getDefaultPolicyJson = (version) => {
    return {
        "Version": version,
        "Statement": [
            /*
            {
                "Effect": "Allow",
                "Action": [
                    "service:Activity"
                ],
                "Resource": "orn"
            }
            */
        ]
        //, Resource: 'orn:...'
    }
}

const makeActionString = (service, activity) => {
    return `${service}:${activity}`
}

const parseAction = (actionString) => {
    const [service, activity] = actionString.split(':')
    return {
        service,
        activity
    }
}

const populateActionMap = (resourceToActions, policy) => {
    policy.document.Statement.forEach(s => {
        const resources = []
        if (s.Resource instanceof Array) {
            s.Resource.forEach(resource => resources.push(resource))
        }
        else if (typeof s.Resource === 'string') {
            resources.push(s.Resource)
        }
        else {
            throw new Error('Unsupported resource data type, should be string or array of strings')
        }

        resources.forEach((resource) => {
            if (!resourceToActions[resource]) {
                resourceToActions[resource] = {}
            }
            const actions = resourceToActions[resource]
            s.Action.forEach(action => {
                const a = parseAction(action)
                if (!actions[a.service]) {
                    actions[a.service] = {}
                }
                if (Wildcard === a.activity) {
                    actions[a.service] = {}
                }
                if (!actions[a.service][Wildcard]) {
                    actions[a.service][a.activity] = true
                }
            })
        })
    })
}

const asArray = (value) => {
    return Array.isArray(value) ? value : [value]
}

/**
 * Takes a policy as a JSON object and returns a map of services keyed by
 * resource and activities keyed by service.
 * @param document
 */
const getActionsByResource = (document) => {
    const tree = {}
    if (!Array.isArray(document.Statement)) {
        return tree
    }
    document.Statement.forEach(statement => {
        if (Effect.Allow !== statement.Effect) {
            return
        }
        if (undefined === statement.Resource) {
            return
        }
        const resources = asArray(statement.Resource)
        resources.forEach(resource => {
            if (!tree[resource]) {
                tree[resource] = {}
            }
        })
        if (!Array.isArray(statement.Action)) {
            return
        }
        statement.Action.forEach(action => {
            const a = parseAction(action)
            resources.forEach(resource => {
                if (!tree[resource][a.service]) {
                    tree[resource][a.service] = {}
                }
                if (undefined !== a.activity) {
                    tree[resource][a.service][a.activity] = true
                }
            })
        })
    })
    return Object.freeze(tree)
}

const DEFAULT_RESOURCE_TEMPLATE = 'orn:entity:{{entityId}}'

const resolveResourceTemplate = (resource, tokens) => {
    if (!tokens || typeof tokens !== 'object' || Array.isArray(tokens)) {
        throw new Error('"tokens" argument must be an object')
    }

    if (Array.isArray(resource)) {
        return resource.map(resource => resolveResourceTemplate(resource, tokens))
    }

    switch (typeof resource) {
        case 'undefined':
        case 'string': {
            if (!resource) {
                resource = DEFAULT_RESOURCE_TEMPLATE
            }

            const template = Handlebars.compile(resource)
            return template(tokens)
        }

        default: {
            throw new Error("Unsupported Policy Resource Type")
        }
    }
}

module.exports = {
    asArray,
    Wildcard,
    PolicyStatementEffect: Effect,
    getActionsByResource,
    getDefaultPolicyJson,
    makeActionString,
    parseAction,
    populateActionMap,
    resolveResourceTemplate
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/common/util.js
// module id = 45
// module chunks = 51